var render = function render(){var _vm=this,_c=_vm._self._c;return _c('draggable',{staticClass:"draggable-list-container",attrs:{"move":_vm.checkMove},model:{value:(_vm.tabs),callback:function ($$v) {_vm.tabs=$$v},expression:"tabs"}},_vm._l((_vm.tabs),function(tab){return _c('draggable-filter-tab',{key:tab.id,attrs:{"draggable-tab":tab},on:{"onChangeTab":_vm.onChangeTab}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }